import { render } from "./Inquiry.vue?vue&type=template&id=5276fa49&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"

import "./Inquiry.vue?vue&type=style&index=0&id=5276fa49&scoped=true&lang=css"
import "./css/forum-portal.css?vue&type=style&index=1&lang=css&external"
import "./css/inquiry-portal.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5276fa49"]])

export default __exports__